/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('componentEditorSource', [
  '$location',

  function ($location) {
    return {
      controller: 'ComponentEditorSourceController',

      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./_component-editor-source.html'),

      replace: true,

      link(scope, element, attrs) {},
    };
  },
]);
